module.exports = ".page-detail-wrapper .card-body > p {\n  font-size: 18px; }\n"